/* libs/shared/src/lib/ui/sidenav-item/sidenav-item.component.scss */
.sidenav-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}
.sidenav-item a.mat-mdc-list-item {
  --mdc-list-list-item-label-text-size: 13px;
  height: 34px;
  padding-left: 5px;
  padding-right: 40px !important;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
}
.sidenav-item a.mat-mdc-list-item .route-icon {
  margin-right: 8px;
  flex-shrink: 0;
  display: inline-block;
  max-width: 20px;
  width: 20px;
  font-size: 15px;
}
.sidenav-item a.mat-mdc-list-item .route-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 3px;
}
.sidenav-item a.mat-mdc-list-item.active {
  background: var(--primary-color-light);
  box-shadow: inset 3px 0 0 0 var(--primary-color);
  border-radius: 6px;
  margin-left: -12px;
  margin-right: -12px;
  padding-left: 17px;
}
.sidenav-item a.mat-mdc-list-item.active .route-icon,
.sidenav-item a.mat-mdc-list-item.active .route-text {
  color: var(--primary-color);
  font-weight: 500;
}
.sidenav-item a.mat-mdc-list-item:hover {
  border-radius: 6px;
  margin-left: -12px;
  margin-right: -12px;
  padding-left: 17px;
}
.sidenav-item a.mat-mdc-list-item:hover:not(.active) {
  background: var(--background-light);
}
.sidenav-item .favorite-star {
  position: absolute;
  right: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
  opacity: 0;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    color 0.2s;
  color: #9ca3af;
  font-size: 15px;
  z-index: 10;
  padding: 5px;
}
.sidenav-item .favorite-star i {
  pointer-events: none;
  color: inherit;
}
.sidenav-item .favorite-star:hover {
  color: #f59e0b;
  transform: scale(1.2);
}
.sidenav-item .favorite-star.is-favorite {
  opacity: 1 !important;
  color: #f59e0b;
}
.sidenav-item .favorite-star.is-loading {
  pointer-events: none;
  opacity: 0.6;
}
.sidenav-item .favorite-star.is-loading .fa-spinner {
  color: #ffd700;
}
.sidenav-item:hover .favorite-star {
  opacity: 1;
}
.sidenav-item.locked a.mat-mdc-list-item {
  opacity: 0.5;
  cursor: default;
}
.sidenav-item.locked:hover .favorite-star {
  opacity: 0;
}
.sidenav-item .lock-indicator {
  position: absolute;
  right: 5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  z-index: 10;
  opacity: 1;
}
.sidenav-item .lock-indicator .lock-icon {
  font-size: 11px;
  color: var(--text-muted, #868e96);
}
.sidenav-item .lock-indicator .tier-badge {
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--text-muted, #868e96);
  background: rgba(134, 142, 150, 0.15);
  padding: 1px 5px;
  border-radius: 3px;
  line-height: 1.4;
  letter-spacing: 0.3px;
}
/*# sourceMappingURL=sidenav-item.component.css.map */
